import { X } from '@music-vine/cadence/icons';
import styles from '@/components/Modals/ConfirmDownload/styles.module.css';
import SteppedDialog from '@/components/SteppedDialog';
import theme from '@/components/SteppedDialog/themes/default.module.css';
import { Button } from '@music-vine/cadence/ui';
import { useAnyPlayerActive } from '@/hooks/media/useAnyPlayerActive';
import { cn } from '@/lib/utils';
import type { ComponentPropsWithoutRef } from 'react';
type SteppedDialogContentContainerProps = ComponentPropsWithoutRef<typeof SteppedDialog.Content>;
export const SteppedDialogContentContainer = ({
  children,
  ...props
}: SteppedDialogContentContainerProps) => {
  const anyPlayerActive = useAnyPlayerActive();
  return <SteppedDialog.Content className={cn(styles.DialogContent, 'bg-white shadow-100 dark:bg-gray-875', 'z-[var(--stepped-dialog-z-index)] border border-gray-200 border-solid px-5 py-6 dark:border-gray-800', {
    // The footer player lifts the sidebar icons by its own height
    'bottom-[86px]!': anyPlayerActive
  })} {...props} data-sentry-element="SteppedDialog.Content" data-sentry-component="SteppedDialogContentContainer" data-sentry-source-file="SteppedDialogContentContainer.tsx">
      <SteppedDialog.Close asChild data-sentry-element="SteppedDialog.Close" data-sentry-source-file="SteppedDialogContentContainer.tsx">
        <Button aria-label="Close" className={cn(theme.DialogClose, 'size-7 dark:bg-gray-875')} size="icon" variant="transparent" data-sentry-element="Button" data-sentry-source-file="SteppedDialogContentContainer.tsx">
          <X className="size-5" data-sentry-element="X" data-sentry-source-file="SteppedDialogContentContainer.tsx" />
        </Button>
      </SteppedDialog.Close>
      {children}
    </SteppedDialog.Content>;
};